export type VoltTone =
  | "success"
  | "warning"
  | "destructive"
  | "info"
  | "neutral";

export type VoltStatusMap = Record<string, { tone: VoltTone; label: string }>;

export const voltStatus = (
  map: VoltStatusMap,
  status: string | null | undefined,
) =>
  (status != null && Object.hasOwn(map, status) ? map[status] : undefined) ?? {
    tone: "neutral" as const,
    label: status ?? "–",
  };
